import Plyr from 'plyr';
import Alpine from 'alpinejs';
import VideoPlayer from '../interfaces/VideoPlayer';

export default function initVideoCard() {
  Alpine.data(
    'videoCard',
    (modalId: string, videoId: string): VideoPlayer => ({
      player: null,
      isPlaying: false,
      playerElement: null,
      modalId,
      videoId,
      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent || ''),
      init() {
        document.addEventListener('DOMContentLoaded', () => {
          if (!window.verifyCookies || window.verifyCookies()) {
            this.initVideo();
          }
        });
      },
      initVideo() {
        this.player = null;
        this.isPlaying = false;
      },
      onToggle() {
        if (this.isIOS) {
          this.openInYT();
        } else {
          this.createIframe();
        }
      },
      createIframe() {
        this.playerElement = document.querySelector(`#${this.modalId} .video-wrap`);
        if (this.playerElement) {
          const iframeEl = document.createElement('iframe');
          iframeEl.dataset.consent = 'analytics';
          // eslint-disable-next-line @stylistic/max-len
          iframeEl.dataset.src = `https://www.youtube.com/embed/${this.videoId}?autoplay=1&rel=0&modestbranding=1&iv_load_policy=3&controls=0&enablejsapi=1&mute=1&loop=1&playlist=${this.videoId}&origin=${window.location.origin}`;
          // eslint-disable-next-line @stylistic/max-len
          iframeEl.src = `https://www.youtube.com/embed/${this.videoId}?autoplay=1&rel=0&modestbranding=1&iv_load_policy=3&controls=0&enablejsapi=1&mute=1&loop=1&playlist=${this.videoId}&origin=${window.location.origin}`;
          iframeEl.setAttribute('allowfullscreen', '');
          iframeEl.setAttribute('allow', 'autoplay');
          iframeEl.title = 'Play video';
          iframeEl.loading = 'lazy';
          iframeEl.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-forms');

          this.playerElement.appendChild(iframeEl);
          this.initVideoPlayer();
        }
      },
      toggleStatus() {
        if (this.isPlaying) {
          this.pause();
        } else {
          this.play();
        }
      },
      play() {
        if (this.player) {
          this.player.play();
          this.isPlaying = true;
        }
      },
      pause() {
        if (this.player) {
          this.player.pause();
          this.isPlaying = false;
        }
      },
      async initVideoPlayer() {
        if (this.playerElement) {
          this.player = new Plyr(this.playerElement, {
            controls: ['fullscreen', 'play', 'progress', 'current-time', 'mute', 'volume'],
            ratio: '16:9',
            youtube: {
              noCookie: true,
              rel: 0,
              modestbranding: 1,
              showInfo: false,
            },
          });
          if (this.player) {
            this.player.on('ready', () => {
              setTimeout(() => {
                if (this.player) {
                  this.player.play();
                  this.isPlaying = true;
                  const videoModal = document.getElementById(`${this.modalId}`);
                  if (videoModal) {
                    document.body.classList.add('menu-opened');
                    videoModal.classList.add('show');
                  }
                }
              }, 50);
            });
          }
        }
      },
      openInYT() {
        if (this.videoId) {
          window.open(`https://www.youtube.com/watch?v=${this.videoId}`, '_blank');
        }
      },
    }),
  );
}
